<h2>This Week's Meetings
    <i class="fas fa-plus" (click)="toggleThisWeek()" *ngIf="!showThisWeek"></i>
    <i class="fas fa-minus" (click)="toggleThisWeek()" *ngIf="showThisWeek"></i>
</h2>
<div class="cardWrapGroup" *ngIf="showThisWeek">
    <div *ngFor="let class of thisWeekClasses">
        <div [ngClass]="{cardWrap: true, blackBorder: class.name.indexOf('Funeral') >= 0 }">
            <div class="card-body">
                <h5 class="card-title"><a [href]="class.link" [title]="class.name">{{ class.name }}</a></h5>
                <p class="card-text">{{class.description}}</p>
                <p class="card-text">{{class.time}}</p>
                <p class="card-text" *ngIf="class.lesson">
                    Lesson: <span *ngIf="class.lesson.link"><a [href]="class.lesson.link" [title]="class.lesson.link">{{class.lesson.lesson}}</a></span>
                    <span *ngIf="!class.lesson.link">{{class.lesson.lesson}}</span>
                </p>
                <a [href]="class.link" [title]="class.name" class="btn btn-primary">{{ class.buttonLabel }}</a>
            </div>
        </div>
    </div>
</div>
<div style="clear:both"></div>
<h2>Next Week's Meetings 
    <i class="fas fa-plus" (click)="toggleNextWeek()" *ngIf="!showNextWeek"></i>
    <i class="fas fa-minus" (click)="toggleNextWeek()" *ngIf="showNextWeek"></i>
</h2>
<div class="cardWrapGroup" *ngIf="showNextWeek">
    <div *ngFor="let class of nextWeekClasses">
        <div [ngClass]="{cardWrap: true, blackBorder: class.name.indexOf('Funeral') >= 0 }">
            <div class="card-body">
                <h5 class="card-title"><a [href]="class.link" [title]="class.name">{{ class.name }}</a></h5>
                <p class="card-text">{{class.description}}</p>
                <p class="card-text">{{class.time}}</p>
                <p class="card-text" *ngIf="class.lesson">
                    Lesson: <span *ngIf="class.lesson.link"><a [href]="class.lesson.link" [title]="class.lesson.link">{{class.lesson.lesson}}</a></span>
                    <span *ngIf="!class.lesson.link">{{class.lesson.lesson}}</span>
                </p>
                <a [href]="class.link" [title]="class.name" class="btn btn-primary">{{ class.buttonLabel }}</a>
            </div>
        </div>
    </div>
</div>